<div
  class="status-badge-wrapper sg-status-badge-{{ status }} sg-ui-component"
  [ngClass]="{
    'with-border': withBorder,
    inverted: inverted,
    'sg-status-badge-small': size === 'small',
    'sg-status-badge-default': size === 'default',
  }">
  @if (withDot) {
    <div class="dot"></div>
  }
  <sg-text variant="sg-body-small-bold">{{ text }}</sg-text>
</div>
